import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '@/store/types';
import { IUserState } from '../../interfaces';

export const state: IUserState = {
  currentUserRole: 'admin',
  permissions: [],
  currentCompany: '',
  currentCompanyId: null,
};

const namespaced = true;

export const userState: Module<IUserState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
